package org.lennycodes.gradematewebsite


import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

/** null = loading, false = signed out, true = signed in */
var isAuthenticated by mutableStateOf<Boolean?>(null)
    private set

private var initialized = false

fun ensureAuthStateInitialized() {
    if (initialized) return
    initialized = true
    onAuthStateChanged(FirebaseService.auth) { user ->
        isAuthenticated = (user != null)
    }
}